<script setup>
import {ref, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    id: Number,
    noUserStr: String,
    noUserFoundStr: String,
})

const itemDataStore = useItemDataStore()

// --- State ---

const displayName = ref('')

// --- Methods ---

const resolveName = async () => {
    // 1. Handle ID 0 (usually "No User" or "Not Assigned")
    if (props.id === 0) {
        displayName.value = props.noUserStr || ''
        return
    }

    // 2. Fetch User Data
    try {
        const user = await itemDataStore.get({
            tableName: 'users',
            id: props.id
        })

        if (user) {
            displayName.value = `${user.firstName} ${user.lastName}`
        } else {
            // 3. Handle Case: ID exists but no record returned (Deleted User)
            if (props.noUserFoundStr === '') {
                displayName.value = ''
            } else {
                displayName.value = props.noUserFoundStr || '<em style="font-weight: normal">User not found.</em>'
            }
        }
    } catch (error) {
        displayName.value = '<em style="font-weight: normal">Error loading user.</em>'
    }
}

// --- Watcher ---

// Re-resolve name whenever the ID changes
watch(() => props.id, resolveName, {immediate: true})
</script>

<template>
    <span v-html="displayName"/>
</template>

<style scoped>
/* Ensure the italicized fallback text doesn't look like an input error */
em {
    color: #6c757d;
}
</style>